export var Separator;
(function (Separator) {
  Separator["None"] = "none";
  Separator["Top"] = "top";
  Separator["Bottom"] = "bottom";
})(Separator || (Separator = {}));